var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c("a", { staticClass: "link_thumb", attrs: { href: _vm.url } }, [
      _vm.thumbnail
        ? _c("span", { staticClass: "box_thumb" }, [
            !_vm.isError
              ? _c("img", {
                  staticClass: "img_thumb",
                  attrs: {
                    src: _vm.thumbnail,
                    width: "186",
                    height: "186",
                    alt: ""
                  },
                  on: { error: _vm.onImgLoadingError }
                })
              : _c("span", { staticClass: "img_thumb album_regulate" })
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("strong", { staticClass: "tit_gallery" }, [
      _vm.isCurrentArticle
        ? _c("span", { staticClass: "ico_bbs ico_current" }, [
            _vm._v("현재 보고있는 페이지")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("a", {
        staticClass: "album_article_title",
        attrs: { href: _vm.url },
        domProps: { innerHTML: _vm._s(_vm.title) },
        on: { click: _vm.onTitleClick }
      }),
      _vm._v(" "),
      _vm.isNew
        ? _c("span", { staticClass: "ico_bbs ico_new" }, [_vm._v("새글")])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasComment
        ? _c(
            "a",
            {
              staticClass: "link_count",
              attrs: { href: "javascript:" },
              on: { click: _vm.openCommentPopup }
            },
            [
              _c("span", { staticClass: "num_count_g" }, [
                _c("span", { staticClass: "screen_out" }, [_vm._v("댓글수")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "num_item", class: _vm.commentCntClass },
                  [_vm._v(_vm._s(_vm.shrtcmtcnt))]
                )
              ])
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "opt_more_g txt_item writer_opt " }, [
      _c(
        "a",
        {
          staticClass: "txt_writer",
          attrs: { href: "javascript:" },
          on: { click: _vm._openLayer }
        },
        [_vm._v(_vm._s(_vm.nickname || "(익명)"))]
      )
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "txt_date" }, [_vm._v(_vm._s(_vm.regdtshow))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }